import React from 'react'
import { connect } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { FORM_PESO_CON_REMITO } from '../../../../config/forms'
import { COLORES } from '../../../../config/colores'

function CamposPesoConRemito (props) {
  const { pesadoAuto, cerealVariedad } = props

  const partial = props.exportador.split('-')
  const nombreExportador = partial[0]

  return (
    <div className='container-peso-remito'>
      <div className='container-peso-bruto'>
        <Field
          className='peso-cabezal peso-cabezal-bruto'
          name='pesoBruto'
          component={renderTextField}
          disabled={pesadoAuto}
          label='Peso bruto'
          autoFocus
          maxLength={5}
        />
      </div>

      <div className='info-remito'>
        <h6
          style={{
            backgroundColor: COLORES.grey.dark,
            borderRadius: '5px',
            color: '#ffffff',
            padding: '8px'
          }}
        >
          Remito: <b>{props.numeroRemito}</b>
        </h6>
        <div style={{ display: 'flex' }}>
          <h6>Producto: <b>{props.cereal}</b></h6>
          {cerealVariedad && cerealVariedad.trim() !== 'UNDEF' && <h6 style={{ marginLeft: '22px' }}>Variedad: {cerealVariedad}</h6>}
        </div>
        <h6>Exportador: <b>{nombreExportador}</b></h6>
        <h6>Planta: {props.plantaRemito}</h6>
        <h6>Peso neto origen: {props.netoOrigen}</h6>
      </div>
    </div>
  )
}

const selector = formValueSelector(FORM_PESO_CON_REMITO)

const mapStateToProps = (state) => ({
  exportador: state.pesado.exportadorRemito,
  cereal: selector(state, 'cereal'),
  cerealVariedad: selector(state, 'cerealVariedad'),
  planta: selector(state, 'planta'),
  plantaRemito: state.pesado.plantaRemito,
  netoOrigen: selector(state, 'netoOrigen'),
  numeroRemito: state.pesado.numeroRemito
})

const withRedux = connect(mapStateToProps, null)
const withReduxForm = reduxForm({
  form: FORM_PESO_CON_REMITO,
  destroyOnUnmount: false,
  enableReinitialize: false,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(CamposPesoConRemito))
